import { Flex } from '@mantine/core';
import React from 'react';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import AppIcon from '@/components/AppIcon.tsx';
import { HiOutlinePlus } from 'react-icons/hi2';
import { useHover } from '@mantine/hooks';
import { useEditorState } from '@/state/editorState.ts';

type props = {
  stepId: string;
  elementCount: number;
  onClick: () => void;
};

const StepFieldsAddButton = ({ stepId, elementCount, onClick }: props) => {
  const { hovered, ref: hoverRef } = useHover();

  const setNewStepId = useEditorState((s) => s.setNewStepId);

  return (
    <Flex ref={hoverRef}>
      <StyledButton
        onClick={() => {
          setNewStepId(stepId);
          onClick();
        }}
        variant={'icon'}
        aria-label="Add field"
        w={'100%'}
        style={{ backgroundColor: hovered ? '#E4E4E4' : '#F6F6F6', height: '28px' }}
        mt={elementCount === 0 ? 'xs' : 0}
      >
        <AppIcon Icon={HiOutlinePlus} size={'16px'} iconProps={{ strokeWidth: '2px' }} />
      </StyledButton>
    </Flex>
  );
};

export default StepFieldsAddButton;
